import React, { useState, useEffect } from 'react';
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  styled,
} from '@mui/material';
import Button from '../elements/editors/mui/Button';
import FlowPreviewContainer from '../../components/sendData/summaryViews/FlowPreviewContainer';

const styles = {
  dialogHeader: {
    padding: '8px 24px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 20,
    fontWeight: 400,
  },
  dialogContentText: {
    padding: '0px 24px',
    marginTop: 10,
  },
  dialogDescription: {
    marginTop: 10,
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.6)',
  },
  buttonStyle: {
    width: 'auto',
    height: 30,
    lineHeight: '30px',
    marginLeft: 10,
    marginRight: 10,
  },
};

const muiStyles = {
  dialogTitle: {
    padding: 0,
  },
  dialogContent: {
    padding: 0,
  },
};

const StyledDialogTitle = styled(DialogTitle)(muiStyles.dialogTitle);
const StyledDialogContent = styled(DialogContent)(muiStyles.dialogContent);

const ModalCloneFlow = (props) => {
  const [formFields, setFormFields] = useState({
    reuseDataCredentials: true,
    copyAccessAcontrols: false,
    copyDependentDataFlows: true,
  });

  const _handleSubmit = () => {
    const payload = {
      reuse_data_credentials: formFields.reuseDataCredentials,
      copy_access_controls: formFields.copyAccessAcontrols,
      copy_dependent_data_flows: formFields.copyDependentDataFlows,
    };
    props.cloneFlow(props.data, payload).then((res) => {
      props.setSelectedPipeline?.(res.result.flows.id[0]);
      _cleanup();
    });
  };

  const _handleChange = (e) => {
    let name = e.target.name;
    setFormFields((prevFormFields) => ({
      ...prevFormFields,
      [name]: !prevFormFields[name],
    }));
  };

  useEffect(() => {
    return () => _cleanup;
  }, []);

  const _cleanup = () => {
    props.toggleCloneFlowModal();
  };

  return (
    <Dialog open={!!props.data} onClose={_cleanup} maxWidth="lg" fullWidth>
      {/* Title */}
      <StyledDialogTitle disableTypography>
        <h3 style={styles.dialogHeader}>Duplicate Flow</h3>
        <Divider light />
      </StyledDialogTitle>

      {/* Content */}
      <StyledDialogContent>
        <FormGroup style={styles.dialogContentText}>
          <p style={styles.dialogDescription}>
            Create a copy of the selected Flow. Select the option for reusing Credentials if you do
            not wish to create a copy of Credentials used in the Flow.
          </p>
          <FormControlLabel
            control={
              <Checkbox
                checked={formFields.reuseDataCredentials}
                onChange={_handleChange}
                name="reuseDataCredentials"
                color="primary"
              />
            }
            label="Reuse Credentials Used In Flow"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={formFields.copyAccessAcontrols}
                onChange={_handleChange}
                name="copyAccessAcontrols"
                color="primary"
              />
            }
            label="Copy Access Controls"
          />
        </FormGroup>
        <FlowPreviewContainer nodeKey={props.data.nodeKey} />
      </StyledDialogContent>

      {/* Action buttons */}
      <DialogActions>
        {props.loading.cloneFlowRequest ? (
          <CircularProgress
            className="test-credential-button"
            color="primary"
            size={18}
            thickness={5}
            disableShrink={true}
            style={{ verticalAlign: 'middle' }}
          />
        ) : (
          <>
            <Button buttonTheme="cancel" onClick={_cleanup}>
              Cancel
            </Button>
            <Button buttonTheme="primary" onClick={_handleSubmit}>
              Confirm
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(ModalCloneFlow);
